import type { FaireProductEntity } from "../../entity_types/product";

export const p_gf2xpp56r4: FaireProductEntity = {
  token: "p_gf2xpp56r4",
  type: "product",
  name: "Fall - Maple Bourbon Truffle Bar",
  brandToken: "b_adcrph7h",
  brandName: "Seattle Chocolate Presents Maeve",
  imageUrl:
    "https://cdn.faire.com/fastly/51509280c30f9ee293458816b3b6aac70b8c51fb5bd2ab764650ccc54f43fbfe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b67df8d4fcb87ce4884d0ccf1f070a05286b8ccf282a369ddd27ff8cd3ab8a1f.jpeg",
    "https://cdn.faire.com/fastly/76a03038b1f566ea277204aaf6c377927c1f9293da0a87028f539a073045c0c9.jpeg",
  ],
  priceDollars: 3.66,
  description:
    "Rich dark chocolate meets the smoky warmth of maple and bourbon flavor, like stepping outside on a crisp fall morning when the air smells like trees and last night’s fire. It’s cozy without trying too hard, rugged in all the right ways, and best enjoyed somewhere with boots, flannel, and a view. Made with organic chocolate. (2.5oz)\n\nAbout the fall collection:\nWe're pulling over at the roadside pumpkin patch with spiced chais, we're dunking our apple cider donuts in chocolate at the orchard, and we're definitely sitting around the bonfire with a mug of maple bourbon.\n\n•\tWoman-owned and led\n•\t10% net profits donated to cocoa farmers \n•\tEthically sourced, non-GMO chocolate\n•\tCarbon neutral",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:39.399Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
